import { formatDate } from "../../../../explorer/helpers/CommonHelper";
import useLanguages from "../../../../explorer/hooks/useLanguages";

type TDateComponent = {
    item: any;
    colName: string;
}

const DateComponent = (props: TDateComponent) => {
    
    const dateStr = (
        props.item as {
        [key: string]: any;
        }
      )[props.colName];

    const formattedDate = formatDate(dateStr);
    
    return <>{formattedDate}</>;
};

export default DateComponent;